<template>
    <hts-drawer
        v-model="cVisible"
        size="90%"
        :title="drawerTitle"
        :loading="loading"
        @show="init">
        <trip-content
            v-if="!loading"
            :trip="trip" />
    </hts-drawer>
</template>
<script lang="ts" setup>
import TripContent from './trip-info-content.vue'
const props = defineProps({
  api: {
    type: Object,
    required: true
  }
})

const { api } = toRefs(props)

const loading = ref(true)
const cVisible = ref(false)

const trip = reactive<any>({
  _id: '',
  code: '',
  stages: [],
  stageNames: [],
  timeIn: null,
  timeOut: null,
  vehicleId: null,
  vehicleTempId: null,
  order: {},
  routingPositions: [],
  positions: []
})
const drawerTitle = computed(() => `Thông tin chuyến #${trip.code}`)
const tripId = ref<string | null>(null)

const getData = (silence: boolean = false) => {
  if (!silence) {
    loading.value = true
  }
  $api(api.value, { uriParams: { ID: tripId.value } }).then(({ data }: any) => {
    const temp = (data?.value || {}).data || {}

    temp.travelDetails = combineTravelDetails(temp)
    Object.assign(trip, temp)
    nextTick(() => {
      loading.value = false
    })
  })
}

const combineTravelDetails = (trip: any) => {
  const result: any[] = []
  const { journeys, travelDetails } = trip
  if (Array.isArray(journeys)) {
    const temp: any[] = []
    journeys.forEach((j: any) => {
      const { travelDetails, travelIndexEnd, travelIndexStart } = j
      for (let i = travelIndexStart; i <= travelIndexEnd; i++) {
        temp.push({
          index: i,
          data: travelDetails[i]
        })
      }
    })
    travelDetails.forEach((item: any, i: number) => {
      const exists = temp.find((t: any) => t.index === i)
      if (exists) {
        result.push(exists.data)
      } else {
        result.push(item)
      }
    })
  } else {
    return travelDetails
  }
  return result
}
const init = () => {
  nextTick(() => {
    getData()
  })
}

const show = (id: string) => {
  Object.assign(trip, {
    _id: '',
    code: '',
    stages: [],
    stageNames: [],
    timeIn: null,
    timeOut: null,
    vehicleId: null,
    vehicleTempId: null,
    order: {}
  })
  tripId.value = id
  cVisible.value = true
}

const hide = () => {
  cVisible.value = false
}

const refresh = (id?: string) => {
  if (!cVisible.value) {
    return
  }
  if (id && tripId.value !== id) {
    return
  }

  getData(true)
}

defineExpose({
  show,
  hide,
  refresh
})
</script>
